import {AfterViewInit, Component, forwardRef, Inject, ViewChild} from '@angular/core';
import {BaseModalComponent} from '../../components/base.modal.component';
import {FieldsListComponent} from '../../components/fields-list.component';
import {DeviceBean, DeviceTemplateBean, IngredientBean, KioskBean} from '../../model/model';
import {Field, FieldType} from '../../common/field';
import {Helper} from '../../common/helper';
import {KioskService} from '../../services/kiosk.service';
import {KioskDataService} from '../../services/kiosk-data.service';
import {DeviceTemplateService} from '../../services/device-template.service';
import {AppComponent} from '../../app.component';
import {StoreManagerKioskViewComponent} from './store-manager-kiosk-view.component';

@Component({
    selector: 'store-manager-kiosk-devices-edit-component',
    templateUrl: 'store-manager-kiosk-devices.edit.component.html'
})

export class StoreManagerKioskDevicesEditComponent implements AfterViewInit {

    device: DeviceBean = {} as DeviceBean;

    @ViewChild(BaseModalComponent, {static: false}) base: BaseModalComponent;
    @ViewChild(FieldsListComponent, {static: false}) fieldsListComponent: FieldsListComponent;
    fields: Field[] = [
        new Field('id', 'Device ID').disable(),
        new Field('name', 'Name').require(),
        // new Field('disabled', 'Disabled', FieldType.CHECKBOX),
        // new Field('visionObjectName', 'Vision Object Name'),
        // new Field('visionIngredientName', 'Vision Ingredient Name'),
        new Field('operationType', 'Operation Type', FieldType.SELECT).setOptions(['NORMAL', 'SIMULATION', 'PSEUDO_SIM']),
    ];
    deviceTemplate: DeviceTemplateBean;
    kiosk: KioskBean;
    ingredients: IngredientBean[];
    compareBeans = Helper.compareBeans;

    constructor(private kioskService: KioskService,
        private kioskDataService: KioskDataService,
        private deviceTemplateService: DeviceTemplateService,
        @Inject(forwardRef(() => AppComponent)) private app: AppComponent,
        @Inject(forwardRef(() => StoreManagerKioskViewComponent)) private parent: StoreManagerKioskViewComponent) {
    }

    range = (value) => {
        const a = [];
        for (let i = 0; i < value; ++i) {
            a.push(i);
        }
        return a;
    };

    ngAfterViewInit(): void {
        this.kioskDataService.getData().subscribe(kioskData => {
            this.ingredients = [];
            for (const ingredient of kioskData.value.ingredients) {
                this.ingredients.push(Helper.copyObject(ingredient));
            }
        });

    }

    isValid() {
        return () => {
            return this.fieldsListComponent && this.fieldsListComponent.valid();
        };
    }

    open(kiosk: KioskBean, device: DeviceBean) {

        this.kiosk = kiosk;
        this.device = (device ? Helper.copyObject(device) : {} as DeviceBean);
        if (!this.device.canDispenseIngredients) {
            this.device.canDispenseIngredients = {};
        }

        this.base.show(device == null ? 'Create new Device' : 'Edit ' + device.name);
        this.onDeviceChanged();

        this.deviceTemplateService.getDeviceTemplates().subscribe(deviceTemplates => {

            for (const deviceTemplate of deviceTemplates.list) {
                if (deviceTemplate.id == this.device.deviceTemplateId) {
                    this.deviceTemplate = deviceTemplate;
                }
            }

            Helper.selectPicker('select_hw', 'select_dqt', 'edit_type');
        });
    }

    getIngredients(ingredientType: string) {

        const result = [];
        for (const ingredient of this.ingredients) {
            if (ingredient.type == ingredientType) {
                result.push(ingredient);
            }
        }
        return result;
    }

    onDeviceChanged() {
        setTimeout(() => {
            for (const i of this.range(this.device.numberOfIngredients)) {
                Helper.selectPicker('select_ingredient' + i);
            }
            Helper.selectPicker('select_boosts');

        }, 1);
        if (!this.isIngredient()) {
            this.device.canDispenseIngredients = {};
        }
    }

    isIngredient() {
        return this.device.dispenserType == 'INGREDIENT';
    }

    save() {

        if (Object.keys(this.device.canDispenseIngredients).length == 0) {
            this.device.canDispenseIngredients = null;
        }

        for (const key in this.device.canDispenseIngredients) {
            if (!this.device.canDispenseIngredients[key]) {
                delete this.device.canDispenseIngredients[key];
            }
        }

        console.log(this.device);

        this.kioskService.updateDevice(this.kiosk.id, this.kiosk.operatorId, this.device).subscribe(response => {

            if (response.success) {
                // this.parent.loadDevices();
                this.app.showNotification('Updated');

            } else {
                this.app.showError('Can\'t update device');
            }
        }, error => {
            this.app.showError('Can\'t update device');
        });
    }

}
